import { Navigate, Outlet } from 'react-router-dom';
import { useAppStore } from '@/stores/appStore';

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAppStore();

  // Show spinner only while the initial auth check is in progress AND we
  // don't yet know if the user is authenticated. Once authenticated (e.g.
  // after a successful login), skip the spinner so the user isn't blocked.
  if (isLoading && !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
